import React from "react";
import "./Best_Sellers.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

function Best_Sellers({ data }) {
   const navigate = useNavigate();
  const handleCategoryClick = (item) => {
    // Directly navigate if not
    navigate(
      `/product-listing/${item?.id}?category_name=${encodeURIComponent(
        item?.name
      )}&category_image=${encodeURIComponent(item?.image)}`
    );
  };
  return (
    <>
      <section className="Best_Sellers">
        <div className="container">
          <div className="row">
            <div className="col-md-3">
              <div className="main_holder">
                <div className="text_holder">
                  <p>TOP SELLING PRODUCTS</p>
                  <h5>Best Picks For You</h5>
                </div>
              </div>
            </div>

            <div className="col-md-9">
              <Swiper
                slidesPerView={3.5}
                spaceBetween={20}
                pagination={{
                  dynamicBullets: true,
                  clickable: true,
                }}
                modules={[Pagination, Autoplay]}
                autoplay={{ delay: 1500 }}
                className="common_swiper"
                breakpoints={{
                  0: {
                    slidesPerView: 1.5,
                  },
                  400: {
                    slidesPerView: 2.5,
                  },

                  1200: {
                    slidesPerView: 3,
                  },
                }}
              >
                {data?.map((item) => (
                  <SwiperSlide>
                    <div className="seller_card">
                      <div className="img_holder">
                        <img
                          src={process.env.REACT_APP_IMG_URL + item.image}
                          alt=""
                          className="seller_img"
                        />
                      </div>

                      <div className="text_hodler">
                        <p>{item?.name}</p>
                      </div>

                      <div className="btn_holder">
                        <Button
                          className="Shop_Now"
                          onClick={()=>handleCategoryClick(item)}
                        >
                          Shop Now
                        </Button>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Best_Sellers;
